import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { Radar, TrendingUp, TrendingDown, Minus, Flame, Eye, Users, Briefcase, FileSearch, ExternalLink, Search as SearchIcon } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../components/Sheet';
import { toast } from 'sonner';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
import { Input } from '../components/Input';
const issues = [{
  id: 1,
  name: 'Harga beras melambung',
  vol: '124.512',
  pos: 10,
  neu: 20,
  neg: 70,
  region: 'Jawa, Sumatera',
  tag: 'EKONOMI',
  status: 'ORGANIK',
  trend: 'up',
  platform: 'X, TikTok',
  actors: 142
}, {
  id: 2,
  name: 'Hoaks bansos pangan',
  vol: '89.247',
  pos: 5,
  neu: 15,
  neg: 80,
  region: 'Nasional',
  tag: 'SOSIAL',
  status: 'TERKOORDINASI',
  trend: 'up',
  platform: 'FB, TikTok',
  actors: 1247
}, {
  id: 3,
  name: 'IKN tahap 2',
  vol: '65.110',
  pos: 45,
  neu: 30,
  neg: 25,
  region: 'Kalimantan, Jakarta',
  tag: 'POLITIK',
  status: 'ORGANIK',
  trend: 'down',
  platform: 'X, YT',
  actors: 89
}, {
  id: 4,
  name: 'Demo buruh upah minimum',
  vol: '52.430',
  pos: 15,
  neu: 25,
  neg: 60,
  region: 'Jabar, Banten',
  tag: 'EKONOMI',
  status: 'TERKOORDINASI',
  trend: 'up',
  platform: 'X, IG',
  actors: 312
}, {
  id: 5,
  name: 'Hilirisasi nikel',
  vol: '48.220',
  pos: 55,
  neu: 25,
  neg: 20,
  region: 'Sulawesi',
  tag: 'EKONOMI',
  status: 'ORGANIK',
  trend: 'flat',
  platform: 'X, Media',
  actors: 67
}, {
  id: 6,
  name: 'BBM subsidi tepat sasaran',
  vol: '41.890',
  pos: 30,
  neu: 40,
  neg: 30,
  region: 'Nasional',
  tag: 'EKONOMI',
  status: 'ORGANIK',
  trend: 'down',
  platform: 'X, FB',
  actors: 203
}, {
  id: 7,
  name: 'Banjir Demak',
  vol: '38.654',
  pos: 10,
  neu: 30,
  neg: 60,
  region: 'Jawa Tengah',
  tag: 'SOSIAL',
  status: 'ORGANIK',
  trend: 'up',
  platform: 'TikTok, IG',
  actors: 178
}, {
  id: 8,
  name: 'Deepfake suara Menteri X',
  vol: '22.001',
  pos: 2,
  neu: 8,
  neg: 90,
  region: 'Nasional',
  tag: 'KEAMANAN',
  status: 'TERKOORDINASI',
  trend: 'up',
  platform: 'TikTok',
  actors: 45
}, {
  id: 9,
  name: 'Konflik agraria Wadas',
  vol: '19.220',
  pos: 8,
  neu: 22,
  neg: 70,
  region: 'Jawa Tengah',
  tag: 'SOSIAL',
  status: 'ORGANIK',
  trend: 'flat',
  platform: 'X, IG',
  actors: 56
}, {
  id: 10,
  name: 'MBG (Makan Bergizi Gratis)',
  vol: '78.412',
  pos: 60,
  neu: 25,
  neg: 15,
  region: 'Nasional',
  tag: 'SOSIAL',
  status: 'ORGANIK',
  trend: 'up',
  platform: 'TikTok, YT',
  actors: 234
}, {
  id: 11,
  name: 'Pajak hiburan 75%',
  vol: '34.110',
  pos: 5,
  neu: 15,
  neg: 80,
  region: 'Bali, Jakarta',
  tag: 'EKONOMI',
  status: 'ORGANIK',
  trend: 'down',
  platform: 'X, IG',
  actors: 112
}, {
  id: 12,
  name: 'Kunjungan Presiden Papua',
  vol: '28.560',
  pos: 40,
  neu: 35,
  neg: 25,
  region: 'Papua',
  tag: 'POLITIK',
  status: 'ORGANIK',
  trend: 'up',
  platform: 'X, Media',
  actors: 78
}, {
  id: 13,
  name: 'Operasi tagar #TolakKebijakanX',
  vol: '17.330',
  pos: 5,
  neu: 10,
  neg: 85,
  region: 'Nasional',
  tag: 'POLITIK',
  status: 'TERKOORDINASI',
  trend: 'up',
  platform: 'X',
  actors: 1247
}, {
  id: 14,
  name: 'Sawit dan deforestasi',
  vol: '15.880',
  pos: 20,
  neu: 30,
  neg: 50,
  region: 'Sumatera, Kalimantan',
  tag: 'EKONOMI',
  status: 'ORGANIK',
  trend: 'flat',
  platform: 'YT, Media',
  actors: 92
}, {
  id: 15,
  name: 'Konflik antar suporter bola',
  vol: '14.210',
  pos: 5,
  neu: 15,
  neg: 80,
  region: 'Jawa Timur',
  tag: 'SOSIAL',
  status: 'ORGANIK',
  trend: 'down',
  platform: 'X, TikTok',
  actors: 145
}];
const tags = ['Semua', 'IDEOLOGI', 'POLITIK', 'EKONOMI', 'SOSIAL', 'BUDAYA', 'PERTAHANAN', 'KEAMANAN'];
const statuses = ['Semua', 'ORGANIK', 'TERKOORDINASI'];
export function HotIssue() {
  const [tag, setTag] = useState('Semua');
  const [statusFilter, setStatusFilter] = useState('Semua');
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<(typeof issues)[0] | null>(null);
  const filtered = issues.filter(i => {
    if (tag !== 'Semua' && i.tag !== tag) return false;
    if (statusFilter !== 'Semua' && i.status !== statusFilter) return false;
    if (search && !i.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const resetFilters = () => {
    setTag('Semua');
    setStatusFilter('Semua');
    setSearch('');
  };
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1976">
      <PageHeader group="Radar Isu" title="Hot Issue Radar" description="Pemantauan isu viral lintas platform dengan klasifikasi IPOLEKSOSBUDHANKAM dan deteksi koordinasi." icon={Radar} data-id="element-1977" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-1978">
        {[{
        label: 'Total Isu 24J',
        value: '37',
        tone: 'orange',
        icon: Flame,
        sub: '+5 dari kemarin'
      }, {
        label: 'Volume Total',
        value: '648K',
        tone: 'primary',
        icon: TrendingUp,
        sub: 'mention 24 jam'
      }, {
        label: 'Terkoordinasi',
        value: '8',
        tone: 'amber',
        icon: Eye,
        sub: 'jaringan terdeteksi'
      }, {
        label: 'Sentimen Negatif',
        value: '62%',
        tone: 'red',
        icon: TrendingDown,
        sub: 'dari total mention'
      }].map(k => {
        const tones: Record<string, {
          bar: string;
          bg: string;
          border: string;
          text: string;
        }> = {
          orange: {
            bar: 'from-orange-400 to-orange-600',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
            text: 'text-orange-600'
          },
          primary: {
            bar: 'from-primary/60 to-primary',
            bg: 'bg-primary/10',
            border: 'border-primary/20',
            text: 'text-primary'
          },
          amber: {
            bar: 'from-amber-400 to-amber-600',
            bg: 'bg-amber-50',
            border: 'border-amber-200',
            text: 'text-amber-600'
          },
          red: {
            bar: 'from-red-400 to-red-600',
            bg: 'bg-red-50',
            border: 'border-red-200',
            text: 'text-red-600'
          }
        };
        const t = tones[k.tone];
        return <Card key={k.label} className="bg-card border-border/60 overflow-hidden relative hover:shadow-md transition-all" data-id="element-1979">
              <div className={`absolute top-0 left-0 w-1 h-full bg-gradient-to-b ${t.bar}`} data-id="element-1980" />
              <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-1981">
                <div className="flex items-start justify-between gap-2" data-id="element-1982">
                  <div className="min-w-0" data-id="element-1983">
                    <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground truncate" data-id="element-1984">
                      {k.label}
                    </p>
                    <p className="font-heading text-2xl sm:text-3xl font-bold mt-1 tracking-tight" data-id="element-1985">
                      {k.value}
                    </p>
                    <p className="font-mono text-[10px] text-muted-foreground mt-1 truncate" data-id="element-1986">
                      {k.sub}
                    </p>
                  </div>
                  <div className={`size-8 rounded-md ${t.bg} border ${t.border} flex items-center justify-center shrink-0`} data-id="element-1987">
                    <k.icon className={`size-4 ${t.text}`} data-id="element-1988" />
                  </div>
                </div>
              </CardContent>
            </Card>;
      })}
      </div>

      <Card className="bg-card border-border/50" data-id="element-1989">
        <CardContent className="p-0" data-id="element-1990">
          <div className="flex items-center gap-3 px-4 py-3 border-b border-border/50 flex-wrap" data-id="element-1991">
            <div className="relative flex-1 min-w-[200px]" data-id="element-1992">
              <SearchIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 size-3.5 text-muted-foreground" data-id="element-1993" />
              <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Cari isu..." className="pl-8 h-8 text-xs bg-muted/30 border-border/50" data-id="element-1994" />
            </div>

            <div className="flex items-center gap-1.5 flex-wrap" data-id="element-1995">
              {tags.map(t => <button key={t} onClick={() => setTag(t)} className={`font-mono text-[10px] uppercase px-2.5 py-1 rounded border transition ${tag === t ? 'bg-primary text-primary-foreground border-primary' : 'bg-muted/30 text-muted-foreground border-border/50 hover:bg-muted'}`} data-id="element-1996">
                  {t}
                </button>)}
            </div>

            <div className="flex items-center gap-1.5 flex-wrap" data-id="element-1997">
              {statuses.map(s => <button key={s} onClick={() => setStatusFilter(s)} className={`font-mono text-[10px] uppercase px-2.5 py-1 rounded border transition ${statusFilter === s ? 'bg-amber-500/15 text-amber-700 border-amber-300' : 'bg-muted/30 text-muted-foreground border-border/50 hover:bg-muted'}`} data-id="element-1998">
                  {s}
                </button>)}
            </div>

            <span className="ml-auto font-mono text-[10px] text-muted-foreground" data-id="element-1999">
              {filtered.length} isu
            </span>
          </div>

          {filtered.length > 0 ? <div className="overflow-x-auto" data-id="element-2000">
              <Table data-id="element-2001">
                <TableHeader className="bg-muted/20" data-id="element-2002">
                  <TableRow className="hover:bg-transparent border-border/50" data-id="element-2003">
                    <TableHead className="font-mono text-[9px]" data-id="element-2004">ISU</TableHead>
                    <TableHead className="font-mono text-[9px] text-right" data-id="element-2005">
                      VOL
                    </TableHead>
                    <TableHead className="font-mono text-[9px] w-[120px]" data-id="element-2006">
                      SENTIMEN
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-2007">
                      WILAYAH
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-2008">
                      PLATFORM
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-2009">TAG</TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-2010">
                      STATUS
                    </TableHead>
                    <TableHead className="font-mono text-[9px] text-right" data-id="element-2011">
                      AKTOR
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-2012"></TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody data-id="element-2013">
                  {filtered.map(i => <TableRow key={i.id} className="border-border/30 hover:bg-muted/10 cursor-pointer" onClick={() => setSelected(i)} data-id="element-2014">
                      <TableCell className="py-2 text-xs font-medium" data-id="element-2015">
                        {i.name}
                      </TableCell>
                      <TableCell className="py-2 text-xs font-mono text-right" data-id="element-2016">
                        {i.vol}
                      </TableCell>
                      <TableCell className="py-2" data-id="element-2017">
                        <div className="flex w-full h-1.5 rounded-full overflow-hidden bg-muted" data-id="element-2018">
                          <div className="bg-emerald-500 h-full" style={{
                      width: `${i.pos}%`
                    }} data-id="element-2019" />
                          <div className="bg-muted-foreground/50 h-full" style={{
                      width: `${i.neu}%`
                    }} data-id="element-2020" />
                          <div className="bg-red-500 h-full" style={{
                      width: `${i.neg}%`
                    }} data-id="element-2021" />
                        </div>
                      </TableCell>
                      <TableCell className="py-2 text-[10px] text-muted-foreground" data-id="element-2022">
                        {i.region}
                      </TableCell>
                      <TableCell className="py-2 font-mono text-[9px] text-muted-foreground" data-id="element-2023">
                        {i.platform}
                      </TableCell>
                      <TableCell className="py-2" data-id="element-2024">
                        <span className="font-mono text-[9px] px-1.5 py-0.5 bg-muted rounded text-muted-foreground border border-border/50" data-id="element-2025">
                          {i.tag}
                        </span>
                      </TableCell>
                      <TableCell className="py-2" data-id="element-2026">
                        <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${i.status === 'TERKOORDINASI' ? 'bg-amber-500/10 text-amber-500' : 'bg-blue-500/10 text-blue-500'}`} data-id="element-2027">
                          {i.status}
                        </Badge>
                      </TableCell>
                      <TableCell className="py-2 text-xs font-mono text-right" data-id="element-2028">
                        {i.actors}
                      </TableCell>
                      <TableCell className="py-2 text-right" data-id="element-2029">
                        {i.trend === 'up' ? <TrendingUp className="size-3 text-red-500 inline" data-id="element-2030" /> : i.trend === 'down' ? <TrendingDown className="size-3 text-emerald-500 inline" data-id="element-2031" /> : <Minus className="size-3 text-muted-foreground inline" data-id="element-2032" />}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div> : <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-id="element-2033">
              <SearchIcon className="size-10 text-muted-foreground/40 mb-3" data-id="element-2034" />
              <p className="text-sm font-medium text-foreground mb-1" data-id="element-2035">
                Tidak ada isu sesuai filter
              </p>
              <p className="text-xs text-muted-foreground mb-4" data-id="element-2036">
                Coba ubah kata kunci atau reset filter untuk melihat semua isu.
              </p>
              <Button variant="outline" size="sm" onClick={resetFilters} data-id="element-2037">
                Reset Filter
              </Button>
            </div>}
        </CardContent>
      </Card>

      <RelatedWorkflow currentStep="Deteksi Isu" nextSteps={[{
      to: '/actor-network',
      icon: Users,
      label: 'Lihat Aktor Terkait',
      desc: 'Petakan akun & klaster di balik isu ini.'
    }, {
      to: '/command-tasking',
      icon: Briefcase,
      label: 'Buat Tasking K/L',
      desc: 'Delegasikan respons ke kementerian terkait.'
    }, {
      to: '/case-management',
      icon: FileSearch,
      label: 'Buat Berkas Kasus',
      desc: 'Eskalasi ke pipeline penindakan hukum.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Kirim takedown request ke platform sosial.',
      badge: 'EKSTERNAL'
    }]} data-id="element-2038" />

      <Sheet open={!!selected} onOpenChange={o => !o && setSelected(null)} data-id="element-2039">
        <SheetContent className="w-full sm:max-w-md bg-background border-border/60 p-0 flex flex-col" data-id="element-2040">
          {selected && <>
              <SheetHeader className="p-6 pb-4 border-b border-border/60" data-id="element-2041">
                <div className="flex items-center gap-2 mb-2" data-id="element-2042">
                  <span className="font-mono text-[9px] px-1.5 py-0.5 bg-muted rounded text-muted-foreground border border-border/60" data-id="element-2043">
                    {selected.tag}
                  </span>
                  <Badge variant="outline" className={`font-mono text-[9px] px-1.5 py-0 h-4 ${selected.status === 'TERKOORDINASI' ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-blue-50 text-blue-700 border-blue-200'}`} data-id="element-2044">
                    {selected.status}
                  </Badge>
                  {selected.trend === 'up' && <span className="ml-auto flex items-center gap-1 font-mono text-[10px] text-red-600" data-id="element-2045">
                      <TrendingUp className="size-3" data-id="element-2046" /> NAIK
                    </span>}
                  {selected.trend === 'down' && <span className="ml-auto flex items-center gap-1 font-mono text-[10px] text-emerald-700" data-id="element-2047">
                      <TrendingDown className="size-3" data-id="element-2048" /> TURUN
                    </span>}
                  {selected.trend === 'flat' && <span className="ml-auto flex items-center gap-1 font-mono text-[10px] text-muted-foreground" data-id="element-2049">
                      <Minus className="size-3" data-id="element-2050" /> STABIL
                    </span>}
                </div>
                <SheetTitle className="text-foreground text-lg leading-tight" data-id="element-2051">
                  {selected.name}
                </SheetTitle>
                <SheetDescription data-id="element-2052">
                  Detail intelijen isu — wilayah, aktor, dan rekomendasi.
                </SheetDescription>
              </SheetHeader>

              <div className="flex-1 overflow-y-auto p-6 space-y-5" data-id="element-2053">
                <div className="grid grid-cols-2 gap-3" data-id="element-2054">
                  <div className="p-3 rounded-lg border border-border/60 bg-card" data-id="element-2055">
                    <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2056">
                      Volume
                    </p>
                    <p className="font-heading text-2xl font-bold tracking-tight mt-1" data-id="element-2057">
                      {selected.vol}
                    </p>
                    <p className="font-mono text-[9px] text-muted-foreground" data-id="element-2058">
                      mention 24 jam
                    </p>
                  </div>
                  <div className="p-3 rounded-lg border border-border/60 bg-card" data-id="element-2059">
                    <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2060">
                      Aktor
                    </p>
                    <p className="font-heading text-2xl font-bold tracking-tight mt-1" data-id="element-2061">
                      {selected.actors}
                    </p>
                    <p className="font-mono text-[9px] text-muted-foreground" data-id="element-2062">
                      akun terlibat
                    </p>
                  </div>
                </div>

                <div className="p-3 rounded-lg border border-border/60 bg-card" data-id="element-2063">
                  <div className="flex items-center justify-between mb-2" data-id="element-2064">
                    <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2065">
                      Distribusi Sentimen
                    </p>
                    <p className="font-mono text-[10px] text-muted-foreground" data-id="element-2066">
                      100%
                    </p>
                  </div>
                  <div className="flex w-full h-2 rounded-full overflow-hidden bg-muted" data-id="element-2067">
                    <div className="bg-emerald-500 h-full" style={{
                  width: `${selected.pos}%`
                }} data-id="element-2068" />
                    <div className="bg-muted-foreground/40 h-full" style={{
                  width: `${selected.neu}%`
                }} data-id="element-2069" />
                    <div className="bg-red-500 h-full" style={{
                  width: `${selected.neg}%`
                }} data-id="element-2070" />
                  </div>
                  <div className="grid grid-cols-3 gap-2 mt-2.5" data-id="element-2071">
                    <div className="flex flex-col" data-id="element-2072">
                      <span className="font-mono text-[9px] text-muted-foreground" data-id="element-2073">
                        POSITIF
                      </span>
                      <span className="font-mono text-xs font-bold text-emerald-700" data-id="element-2074">
                        +{selected.pos}%
                      </span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-2075">
                      <span className="font-mono text-[9px] text-muted-foreground" data-id="element-2076">
                        NETRAL
                      </span>
                      <span className="font-mono text-xs font-bold text-muted-foreground" data-id="element-2077">
                        {selected.neu}%
                      </span>
                    </div>
                    <div className="flex flex-col items-end" data-id="element-2078">
                      <span className="font-mono text-[9px] text-muted-foreground" data-id="element-2079">
                        NEGATIF
                      </span>
                      <span className="font-mono text-xs font-bold text-red-700" data-id="element-2080">
                        −{selected.neg}%
                      </span>
                    </div>
                  </div>
                </div>

                <div data-id="element-2081">
                  <p className="font-mono text-[10px] uppercase text-muted-foreground mb-2" data-id="element-2082">
                    Detail
                  </p>
                  <div className="rounded-lg border border-border/60 bg-card divide-y divide-border/60" data-id="element-2083">
                    <DetailRow label="Wilayah" value={selected.region} data-id="element-2084" />
                    <DetailRow label="Platform" value={selected.platform} data-id="element-2085" />
                    <DetailRow label="Klasifikasi" value={selected.tag} data-id="element-2086" />
                    <DetailRow label="Status" value={selected.status} data-id="element-2087" />
                  </div>
                </div>

                <div className="rounded-lg border border-primary/20 bg-primary/5 p-3" data-id="element-2088">
                  <p className="font-mono text-[10px] uppercase text-primary font-bold" data-id="element-2089">
                    Rekomendasi AI Analyst
                  </p>
                  <p className="text-xs text-foreground/80 mt-1.5 leading-relaxed" data-id="element-2090">
                    Eskalasi ke pimpinan Komdigi untuk klarifikasi resmi dalam{' '}
                    <b data-id="element-2091">4 jam</b>. Aktifkan watchlist pada{' '}
                    <b data-id="element-2092">{selected.actors} akun</b> kunci di {selected.platform}.
                  </p>
                </div>
              </div>

              <div className="border-t border-border/60 p-4 flex gap-2 bg-card/50" data-id="element-2093">
                <Button className="flex-1" onClick={() => {
              toast.success('Isu dieskalasi ke pimpinan');
              setSelected(null);
            }} data-id="element-2094">
                  Eskalasi
                </Button>
                <Button variant="outline" className="flex-1" onClick={() => {
              toast.info('Ditambahkan ke watchlist');
              setSelected(null);
            }} data-id="element-2095">
                  + Watchlist
                </Button>
              </div>
            </>}
        </SheetContent>
      </Sheet>
    </div>;
}
function DetailRow({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div className="flex items-center justify-between px-3 py-2.5 text-xs" data-id="element-2096">
      <span className="text-muted-foreground" data-id="element-2097">{label}</span>
      <span className="font-medium text-foreground" data-id="element-2098">{value}</span>
    </div>;
}